import React from 'react'
import { Flex, Box } from 'reflexbox'
import styled from 'styled-components'

import Modal from './Modal'
import Card from 'components/Card'
import Button from 'components/Button'
import { SemiTitle, Text } from 'components/Typography'
import { Close } from 'components/Icons'
import theme from 'styles/theme'
import Loader from 'components/Loader'

const DeleteModal = ({ isOpened, setIsOpened, title, text, onDelete, status }) => {
  const handleDelete = async () => {
    await onDelete()
    setIsOpened(false)
  }

  return (
    <Modal isOpened={isOpened} setIsOpened={setIsOpened}>
      <Card backgroundColor={theme.colors.white} width={588}>
        <Flex flexDirection='column'>
          <Flex alignItems='center' justifyContent='space-between' mb={20}>
            <SemiTitle>{title}</SemiTitle>
            <CloseButton onClick={() => setIsOpened(false)}>
              <Close />
            </CloseButton>
          </Flex>
          <Box mb={30}>
            <Text>{text}</Text>
          </Box>
          <Flex alignItems='center' justifyContent='flex-end'>
            <Button outlined onClick={() => setIsOpened(false)}>
              Cancelar
            </Button>
            <Button disabled={status} onClick={handleDelete} marginLeft={12}>
              {status ? <Loader /> : 'Excluir'}
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Modal>
  )
}

const CloseButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`

export default DeleteModal
